<div class="bize-guvenenler">
  <div class="bize-guvenenler-title">Bize Güvenenler</div>
  <div class="bize-guvenenler-items-wrapper">
    <owl-carousel-o [options]="bizeGuvenenlerOptions" #bizeGuvenenlerCarousel>
      <ng-container *ngFor="let item of data">
        <ng-template carouselSlide>
          <div class="bize-guvenenler-item">
            <img
              src="../../../assets/images/bize-guvenenler/{{ item }}"
              alt=""
            />
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</div>
